import { Avatar, Button, Divider, Flex, Space } from "antd";
import { useNavigate } from "react-router";
import LogoutIcon from "../../../assets/icons/LogoutIcon";
import IMAGES from "../../../assets/images";
import useAuth from "../../../hooks/useAuth";
import { cn } from "../../../utils/global.utils";
import { isActivePath } from "../../../utils/string.utils";
import { userMenuItems } from "../constants";

export default function UserMenu() {
  const navigate = useNavigate();
  const { logout, employee } = useAuth();

  return (
    <div className="min-w-72 bg-white rounded-xl shadow-md">
      {/* User Profile Section */}
      <Flex align="center" gap={16} className="p-4">
        <Avatar
          src={employee?.profilePhotoUrl || IMAGES.avatar}
          size={48}
          className="rounded-full"
        />
        <div>
          <h6 className="text-theme-zinc-700 text-base font-medium">
            {employee?.fullName || employee?.email || "Unknown User"}
          </h6>
          <p className="text-theme-slate-500 text-base font-normal">
            {employee?.phone || "Unknown Phone"}
          </p>
        </div>
      </Flex>

      <Divider style={{ margin: 0 }} />

      {/* Menu Items Section */}
      <div style={{ padding: "8px 0" }}>
        <Space direction="vertical" size={0} style={{ width: "100%" }}>
          {userMenuItems.map((el) => {
            const isActive = isActivePath(1, el.key);

            return (
              <Button
                type="text"
                block
                key={el.key}
                onClick={() => navigate(`/user/${el.key}`)}
                icon={
                  <span
                    className={cn(
                      "relative -top-[1px] text-theme-slate-300",
                      isActive && "text-theme-primary"
                    )}
                  >
                    <el.icon />
                  </span>
                }
                className={cn(
                  "text-theme-zinc-700 text-base font-normal justify-start px-4 py-2 space-x-2",
                  isActive && "!text-theme-primary"
                )}
              >
                {el.label}
              </Button>
            );
          })}
        </Space>
      </div>

      <Divider style={{ margin: 0 }} />

      {/* Logout Section */}
      <div style={{ padding: 16 }}>
        <Button
          type="primary"
          danger
          icon={<LogoutIcon />}
          block
          className="bg-theme-red-500 rounded-full text-sm font-medium"
          onClick={logout}
        >
          লগ আউট
        </Button>
      </div>
    </div>
  );
}
